// Remove the next line when a second export is added to the file
/* eslint-disable import/prefer-default-export */

/**
 * Determines if we can be reasonably sure that the device's memory is somewhat low
 *
 * Because browser support is not great, this function may often return `false` even for devices that do indeed have
 * little memory.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/deviceMemory
 * @see https://caniuse.com/mdn-api_navigator_devicememory
 */
export function hasLimitedMemory(): boolean {
    if (
        typeof navigator !== 'undefined' &&
        'deviceMemory' in navigator &&
        typeof navigator.deviceMemory === 'number' &&
        navigator.deviceMemory > 0
    ) {
        // This number is intentionally altered by the browser to avoid fingerprinting
        // For reference, an M1 MacBook Pro with 32GB reports `8` for this value
        // So we have to take it with a grain of salt and err on the low side
        return navigator.deviceMemory <= 4
    }

    return false
}
